// web/src/registry/sidebarNav.ts —— 侧栏投影（「哪些条目上侧栏」的唯一出口）
//
// 为什么不放在 features.ts 里：那份是登记表（FEATURES / 锚点 / 重定向表），
// 投影是消费侧逻辑，按前端规范 §9「两个可独立命名的关注点必须拆」单独成模块，
// 也让 features.ts 守住 ≤500 行。
//
// 与 `groupedNav()` 分开而不是直接在它里面过滤：导航文档（scripts/gen-nav-doc.mjs）、
// 权限矩阵（scripts/gen-rbac-matrix.mjs）、模块功能地图（featureSearch.ts）与 `navTitleOf`
//（页头名）都要看见全部条目——「暂不上侧栏」（`FeatureNav.hidden`）只影响侧栏这一处渲染。
import { groupedNav, type NavSectionGroup } from './features';

export function sidebarNav(): NavSectionGroup[] {
  return groupedNav()
    .map((s) => ({
      ...s,
      groups: s.groups
        .map((g) => {
          const items = g.items.filter((f) => !f.nav?.hidden);
          // flat 必须按**过滤后**的条目重算：groupedNav 里它按全量算，
          // 否则「可见项全 flat、被隐藏项非 flat」的分组会多包一层无意义的子菜单。
          return { ...g, items, flat: items.every((f) => f.nav?.flat === true) };
        })
        .filter((g) => g.items.length > 0),
    }))
    .filter((s) => s.groups.length > 0);
}
